import { render, staticRenderFns } from "./MyCard.vue?vue&type=template&id=337665f4&scoped=true&"
import script from "./MyCard.vue?vue&type=script&lang=js&"
export * from "./MyCard.vue?vue&type=script&lang=js&"
import style0 from "./MyCard.vue?vue&type=style&index=0&id=337665f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337665f4",
  null
  
)

export default component.exports